import { InfoIcon } from "common/Icons/Icons";
import useConnectExchangeExtraInfo from "features/portfolio/CreateAccount/useConnectExchangeExtraInfo";
import React, { useState } from "react";
import Flex from "common/Boxes/Flex";
import Title from "common/Typography/Title";
import Text from "common/Typography/Text";
import { ExtraInfoType } from "@shared/features/onboarding/types";
import styled, { useTheme } from "styled-components";
import WhitelistIPsMessage from "features/configuration/accounts/CreateAccount/WhitelistIPsMessage";
import { typography } from "@shared/common/Themes/typography";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_SEARCH } from "@shared/common/constants";
import ExpandingCard from "common/Boxes/ExpandingCard";
import { ConfigurationExchangeInfo } from "@shared/types";

interface DrawerExtensionProps {
  primaryExchange?: string;
  selectedSubExchange?: ConfigurationExchangeInfo;
  isQuickConnect?: boolean;
}

const ConnectExchangeGuide = ({
  primaryExchange,
  selectedSubExchange,
  isQuickConnect,
}: DrawerExtensionProps) => {
  const theme = useTheme();
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);
  const [expanded, setExpanded] = useState(false);
  const {
    isDemoWorkspace,
    extraInfoToTitle,
    extraInfoToDescription,
    demoAccountExtraInfo,
    showSignUpExchangeLink,
  } = useConnectExchangeExtraInfo({
    primaryExchange,
    selectedSubExchange,
    isQuickConnect,
  });

  if (isMobile) {
    return (
      <ExpandingCard
        setExpanded={setExpanded}
        expanded={expanded}
        collapsibleContent={
          <div style={{ textAlign: "left" }}>
            {isDemoWorkspace
              ? demoAccountExtraInfo.content
              : extraInfoToDescription[ExtraInfoType.CONNECT_API]}
            {!isDemoWorkspace && showSignUpExchangeLink && (
              <Text style={{ marginTop: 8 }}>
                <span
                  style={{
                    fontWeight: typography.fontWeights.MEDIUM,
                    marginRight: 4,
                  }}
                >
                  {extraInfoToTitle[ExtraInfoType.NO_EXCHANGE_ACCOUNT]}
                </span>
                {extraInfoToDescription[ExtraInfoType.NO_EXCHANGE_ACCOUNT]}
              </Text>
            )}
            {isQuickConnect && (
              <WhitelistIPsMessage primaryExchange={primaryExchange} />
            )}
          </div>
        }
        style={{
          marginTop: 16,
          marginBottom: isDemoWorkspace ? 16 : 0,
          background: theme.isDarkMode
            ? theme.colors.cardLightBgColor
            : theme.colors.statisticsBgColor,
          boxShadow: "none",
        }}
      >
        <Text
          $weight={typography.fontWeights.SEMI_BOLD}
          style={{ textAlign: "center" }}
        >
          {isDemoWorkspace
            ? demoAccountExtraInfo.title
            : extraInfoToTitle[ExtraInfoType.CONNECT_API]}
        </Text>
      </ExpandingCard>
    );
  }

  return (
    <Flex style={{ flexDirection: "column", width: "100%" }}>
      <StyledInfoIcon
        mainColor={theme.colors.primaryGrey}
        secondaryColor={theme.colors.primaryBlue}
      />
      {isDemoWorkspace ? (
        <div style={{ width: "100%" }}>
          <StyledTitle>{demoAccountExtraInfo.title}</StyledTitle>
          {demoAccountExtraInfo.content}
        </div>
      ) : (
        <div style={{ width: "100%" }}>
          <StyledTitle>
            {extraInfoToTitle[ExtraInfoType.CONNECT_API]}
          </StyledTitle>
          {extraInfoToDescription[ExtraInfoType.CONNECT_API]}
          {showSignUpExchangeLink && (
            <Flex style={{ justifyContent: "flex-start", marginTop: 12 }}>
              <Text>
                <span
                  style={{
                    fontWeight: typography.fontWeights.MEDIUM,
                    marginRight: 4,
                  }}
                >
                  {extraInfoToTitle[ExtraInfoType.NO_EXCHANGE_ACCOUNT]}
                </span>
                {extraInfoToDescription[ExtraInfoType.NO_EXCHANGE_ACCOUNT]}
              </Text>
            </Flex>
          )}
          {isQuickConnect && (
            <WhitelistIPsMessage primaryExchange={primaryExchange} />
          )}
        </div>
      )}
    </Flex>
  );
};

export default ConnectExchangeGuide;

const StyledInfoIcon = styled(InfoIcon)`
  width: 125px;
  height: 125px;
  margin-bottom: 20px;
`;
const StyledTitle = styled(Title).attrs({ level: 3 })`
  margin-bottom: 16px;
  font-weight: ${(p) => p.theme.typography.fontWeights.SEMI_BOLD};
`;
